export default env => async (ctx, next) => {
  if (!ctx.env) ctx.env = env
  await next()
}
